<template>
    <div class="overflow-hidden">

        <div class="row">
            <div v-if="tab == 1" class="col" style="background: rgb(247, 247, 247); min-height: 75vh;">
                <div class="container">
                    <div class="d-md-none mt-5">
                              <a href="/" class="link d-inline-flex justify-content-center" style="line-height:1rem"> <img
                            src="images/arrow-left.svg" width="25" alt="Zurück">
                        Zurück</a>
                    </div>
                    <div class="w-100 d-flex justify-content-center mx-auto mt-5 mx-auto" style="max-width: 800px;">
                        <h3 class="text-black text-center headline-strong-1">Bitte geben Sie Ihre Daten ein.
                            Anschließend erhalten Sie den
                            Download-Link.</h3>
                    </div>
                    <div class="form-row mt-3">
                        <div class="form-group col">
                            <div class="d-inline-flex justify-content-center align-items-center">
                                <label class="mb-0 mr-3">Anrede wählen*</label>
                                <label class="check-container mb-0">Frau
                                    <input type="radio" name="salutation" id="salutation_frau" value="Frau"
                                        v-model="formData.salutation" required>
                                    <span class="checkmark"></span>
                                </label>
                                <label class="check-container mb-0">Herr
                                    <input type="radio" name="salutation" id="salutation_herr" value="Herr"
                                        v-model="formData.salutation" required>
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="firstname">Vorname*</label>
                            <input type="text" class="form-control" id="firstname" v-model="formData.firstname"
                                required>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="lastname">Nachname*</label>
                            <input type="text" class="form-control" id="lastname" v-model="formData.lastname" required>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="email">E-Mail*</label>
                            <input type="email" class="form-control" id="email" v-model="formData.email" required>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="phone">Telefonnummer</label>
                            <input type="text" class="form-control" id="phone" v-model="formData.phone">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6 m-0">
                            <div class="d-inline-flex justify-content-center align-items-center h-100 check-container">
                                <p class="m-0"><small class="font-weight-bold">Ich habe die Hinweise zum <a
                                            href="/files/GSI_Datenschutzerklaerung.pdf" target="_blank"
                                            class="text-black"><u>Datenschutz</u></a> gelesen und
                                        akzeptiere sie.*</small>
                                </p>
                                <input type="checkbox" id="terms" value="accepted" v-model="formData.terms" required
                                    style="width:1px">
                                <label for="terms" class="checkmark"></label>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <p class="ml-3 mt-2"><small>*Pflichtfelder <br>
                                    <p class="mt-2"><small>Durch die Anforderung des Whitepapers bestätigen Sie, dass
                                            Sie auch in Zukunft weitere Informationen von uns zu dem Thema erhalten
                                            wollen. Diese Einwilligung erfolgt freiwillig und kann von Ihnen jederzeit
                                            widerrufen werden.</small></p>
                                </small></p>
                        </div>
                    </div>
                    <div class="w-100 d-flex justify-content-center">
                        <button id="sendData" @click.prevent="sendData"
                            class="btn btn-primary text-uppercase font-weight-bold"
                            :disabled="!formData.firstname || !formData.lastname || !formData.email || !formData.salutation || !formData.terms">Anfrage
                            bestätigen</button>
                    </div>
                    <div class="d-none d-md-block">
                          <a href="/" class="link d-inline-flex justify-content-center" style="line-height:1rem"> <img
                            src="images/arrow-left.svg" width="25" alt="Zurück">
                        Zurück</a>
                    </div>
                </div>
            </div>
            <div v-if="tab == 2" class="col">
                <div class="w-100 d-flex justify-content-center">
                    <svg id="loading" version="1.1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="80px" height="80px"
                        viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve">
                        <path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z" />
                        <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
C22.32,8.481,24.301,9.057,26.013,10.047z">
                            <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 20 20"
                                to="360 20 20" dur="0.5s" repeatCount="indefinite" />
                        </path>
                    </svg>
                </div>
            </div>
            <div v-if="tab == 3" class="col p-0 bg-white">


                <div id="banner_thankyou"></div>
                <div class="container">

                    <div class="row">
                        <div class="col">
                            <p class="text-blue font-weight-bold py-4 m-0">Informations-Material anfordern</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col d-flex justify-content-center">
                            <div class="headline-strong-1 my-4 font-weight-bold">Vielen Dank!</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col mb-md-4">
                            <p class="mb-2">
                                Ihre Anforderung weiterer Informationen zur Bauüberwachung ist bei uns eingegangen.
                                <br /><br />
                                <strong>Wir haben von Ihnen folgende Daten erhalten</strong>
                            </p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <div>Vorname: {{formData.firstname}}</div>
                            <div>Nachname: {{formData.lastname}}</div>
                            <div>E-Mail: {{formData.email}}</div>
                            <div>Telefon: {{formData.phone}}</div>
                            <br /><br />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <!-- <p>
                                Sie können hier das Whitepaper mit dem Factsheet für Ihren Arbeitgeber downloaden:
                            </p> -->
                            <a href="https://mcusercontent.com/c7dcfbbe0435b3e2218072f89/files/33840a17-5ff9-8658-ed6f-14e29b0123d0/GSI_SLV_Bauueberwachung_Whitepaper.01.pdf"
                                target="_blank"
                                class="btn btn-primary text-uppercase font-weight-bold mx-auto ml-md-0 text-white">Download
                                Whitepaper</a>

                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-6">
                            <p>Viele Grüße,<br />Ihr GSI SLV Team</p>
                            <br />
                        </div>
                    </div>

                    <div class="d-none d-md-block">
                             <a href="/" class="link d-inline-flex justify-content-center" style="line-height:1rem"> <img
                            src="images/arrow-left.svg" width="25" alt="Zurück">
                        Zurück</a>
                    </div>

                </div>

                <!-- <div class="w-100 d-flex justify-content-center">
                        <div class="success-checkmark">
                            <div class="check-icon">
                                <span class="icon-line line-tip"></span>
                                <span class="icon-line line-long"></span>
                                <div class="icon-circle"></div>
                                <div class="icon-fix"></div>
                            </div>
                        </div>
                    </div>
                    <div class="w-100 d-flex justify-content-center flex-column my-3">
                        <h2 class="text-black text-center">Vielen Dank<br />für Ihr Interesse!</h2>
                        <p class="text-center py-2 m-0">
                            Sie erhalten in Kürze eine E-Mail zur Bestätigung Ihrer Daten.<br />
                            Anschließend gelangen Sie über den Link zurück auf unsere Seite, um das angeforderte
                            Info-Material zu downloaden.
                        </p>
                    </div>
                    <div class="w-100 d-flex justify-content-center">
                        <router-link to="/" tag="button"
                            class="btn btn-primary text-uppercase font-weight-bold mt-4 mb-4">Zurück</router-link>
                    </div> -->
            </div>

            <div v-if="tab == 4" class="col">
                <div v-if="memberExists === false" class="w-100 d-flex justify-content-center flex-column my-3">
                    <h2 class="text-black text-center">Es ist ein Fehler<br />aufgetreten.</h2>
                    <p class="text-center py-2 m-0">Bitte versuchen Sie es erneut.</p>
                </div>
                <div v-if="memberExists === true" class="w-100 d-flex justify-content-center flex-column my-3">
                    <h2 class="text-black text-center">Sie haben sich bereits<br />angemeldet.</h2>
                    <!-- <p class="text-center py-2 m-0">Bitte kontrollieren Sie Ihr E-Mail Postfach sorgfältig.</p> -->
                </div>
                <div class="w-100 d-flex justify-content-center">
                    <router-link to="/" tag="button" class="btn btn-primary text-uppercase font-weight-bold mt-4 mb-4">
                        Zurück</router-link>
                </div>
            </div>
        </div>
    </div>

</template>

<style lang="scss" scoped>
    @import 'resources/sass/_variables.scss';

    h2 {
        font-size: 2.5rem;
    }

    #banner_thankyou {
        background-image: url('/images/wallpaper_thankyou.png');
        height: 455px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: top;
    }

    .success-checkmark {
        width: 80px;
        height: 115px;
        margin: 0 auto;
    }

    .success-checkmark>.check-icon {
        width: 80px;
        height: 80px;
        position: relative;
        border-radius: 50%;
        box-sizing: content-box;
        border: 4px solid $blue;
    }

    .success-checkmark>.check-icon::before {
        top: 3px;
        left: -2px;
        width: 30px;
        transform-origin: 100% 50%;
        border-radius: 100px 0 0 100px;
    }

    .success-checkmark>.check-icon::after {
        top: 0;
        left: 30px;
        width: 60px;
        transform-origin: 0 50%;
        border-radius: 0 100px 100px 0;
        animation: rotate-circle 4.25s ease-in;
    }

    .success-checkmark>.check-icon::after,
    .success-checkmark>.check-icon::before {
        content: '';
        height: 100px;
        position: absolute;
        background: #f7f7f7;
        transform: rotate(-45deg);
    }

    .success-checkmark>.check-icon>.icon-line {
        height: 5px;
        background-color: $blue;
        display: block;
        border-radius: 2px;
        position: absolute;
        z-index: 10;
    }

    .success-checkmark>.check-icon>.line-tip {
        top: 46px;
        left: 14px;
        width: 25px;
        transform: rotate(45deg);
        animation: icon-line-tip 0.75s;
    }

    .success-checkmark>.check-icon>.line-long {
        top: 38px;
        right: 8px;
        width: 47px;
        transform: rotate(-45deg);
        animation: icon-line-long 0.75s;
    }

    .icon-circle {
        top: -4px;
        left: -4px;
        z-index: 10;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        position: absolute;
        box-sizing: content-box;
        border: 4px solid rgba(0, 155, 219, .5);
    }

    .icon-fix {
        top: 8px;
        width: 5px;
        left: 26px;
        z-index: 1;
        height: 85px;
        position: absolute;
        transform: rotate(-45deg);
        background-color: #f7f7f7;
    }

    @keyframes rotate-circle {
        0% {
            transform: rotate(-45deg);
        }

        5% {
            transform: rotate(-45deg);
        }

        12% {
            transform: rotate(-405deg);
        }

        100% {
            transform: rotate(-405deg);
        }
    }

    @keyframes icon-line-tip {
        0% {
            width: 0;
            left: 1px;
            top: 19px;
        }

        54% {
            width: 0;
            left: 1px;
            top: 19px;
        }

        70% {
            width: 50px;
            left: -8px;
            top: 37px;
        }

        84% {
            width: 17px;
            left: 21px;
            top: 48px;
        }

        100% {
            width: 25px;
            left: 14px;
            top: 45px;
        }
    }

    @keyframes icon-line-long {
        0% {
            width: 0;
            right: 46px;
            top: 54px;
        }

        65% {
            width: 0;
            right: 46px;
            top: 54px;
        }

        84% {
            width: 55px;
            right: 0;
            top: 35px;
        }

        100% {
            width: 47px;
            right: 8px;
            top: 38px;
        }
    }

    /* Success Checkmark */

    svg path,
    svg rect {
        fill: $orange;
    }

    .link {
        color: $black;
        font-weight: 700;
        text-decoration: none;
    }

    .link>img {
        margin-right: 5px;
        transition: all 0.2s ease-in-out;
    }

    .link:active>img {
        margin-right: 8px;
    }

    /* The container */
    .check-container {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-left: 25px;
        margin-right: 10px;
        position: relative;
        cursor: pointer;
        user-select: none;
        height: 20px;
    }

    /* Hide the browser's default radio button */
    .check-container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }

    /* Create a custom radio button */
    .check-container input[type="radio"]~.checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 20px;
        width: 20px;
        background-color: #f7f7f7;
        border-radius: 50%;
        border: 1px solid $black;
    }

    .check-container input[type="checkbox"]~.checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 20px;
        width: 20px;
        background-color: #f7f7f7;
        border: 1px solid $black;
        border-radius: 0.25rem;
    }

    /* Create the indicator (the dot/circle - hidden when not checked) */
    .checkmark:after {
        content: "";
        position: absolute;
        opacity: 0;
        transition: all 0.2s ease-in-out;
    }

    /* Show the indicator (dot/circle) when checked */
    .check-container input:checked~.checkmark:after {
        opacity: 1;
    }

    /* Style the indicator (dot/circle) */
    .check-container input[type="radio"]~.checkmark:after {
        top: 5px;
        left: 5px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: $black;
    }

    .check-container input[type="checkbox"]~.checkmark:after {
        top: 3px;
        left: 6px;
        width: 6px;
        height: 10px;
        border-right: 2px solid $black;
        border-bottom: 2px solid $black;
        transform: rotate(40deg);
    }

    @media (max-width: 767px) {
        h2 {
            font-size: 2rem;
        }
    }

</style>

<script>
    export default {
        mounted() {

        },
        data() {
            return {
                tab: 1,
                memberExists: false,
                formData: {
                    salutation: '',
                    firstname: '',
                    lastname: '',
                    email: '',
                    phone: '',
                    terms: null,
                }
            }
        },
        methods: {
            async sendData() {

                this.memberExists = false;
                this.tab = 2;

                let self = this;

                // Recaptcha
                // Execute reCAPTCHA and get the token
                const token = await new Promise((resolve, reject) => {
                    grecaptcha.ready(function () {
                    grecaptcha.execute(window.recaptchaKey, { action: 'submit' }).then(token => {
                        resolve(token);
                    });
                    });
                });

                const url = '/api/whitepaper-submit';
                const data = {
                    email: this.formData.email,
                    firstname: this.formData.firstname,
                    lastname: this.formData.lastname,
                    phone: this.formData.phone,
                    salutation: this.formData.salutation,
                    terms: this.formData.terms,
                    formular: "Whitepaper",
                    token
                };

                // Any issues -> console.log(response);
                axios.post(url, data)
                    .then(response => {
                        if (response.status === 200 && response.data.status !== 400 && response.data !==
                            "Sie haben sich bereits registriert." && response.data !==
                            'Versuchen Sie es bitte erneut.') {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: "whitepaperConversion"
                            });
                            self.tab = 3;
                        } else {
                            if (response.data.title === 'Member Exists' || response.data ===
                                "Sie haben sich bereits registriert.") {
                                self.memberExists = true;
                            }

                            self.tab = 4;
                        }
                    }).catch(function (error) {
                        self.tab = 4;
                    });
            }
        }
    }

</script>
